<template>
  <div class="LevelResult">
    <div class="content">
      <LottieWrapper :options="getOptions" :size="size" ref="Lottie_LevelComplete" :completeHandler="null" />
      <ProgressIndicator :total="3" :active="level" ref="ProgressIndicator" />
      <AchievementIndicator ref="AchievementIndicator" :totalPossibleSucceses="totalPossibleSucceses[game]" :successfulHits="successfulHits"/>
      <ContinueButton :onUserActivity="onUserActivity" :onClick="proceed" ref="ContinueButton" :copy="getContinueButtonCopy" :state="getContinueButtonState" />
    </div>
  </div>
</template>

<script>

import { CONFIG } from '@/config'
import { levelFlickerAudio } from '@/audio'

import ProgressIndicator from '@/components/ProgressIndicator.vue'
import AchievementIndicator from '@/components/AchievementIndicator.vue'
import LottieWrapper from '@/components/LottieWrapper'
import ContinueButton from '@/components/ContinueButton'

import { SVGS } from '@/assets/svgs/locale_map'

import { TimelineLite } from 'gsap'

export default {
  name: 'LevelResult',
  props: {
    onUserActivity: Function
  },
  components: {
    ProgressIndicator,
    AchievementIndicator,
    LottieWrapper,
    ContinueButton
  },
  data() {
    return {
      games: ['dot', 'dial', 'grid'],
      totalPossibleSucceses: { // what does 100% look like, how many hits should the user have gotten
        dot: CONFIG.videoData.dot.totalTargets,
        dial: CONFIG.videoData.dial.totalTargets,
        grid: CONFIG.videoData.grid.totalTargets,
      },
      size: {
        width: 540,
        height: 110
      },
      level: this.$store.state.level,
      game: this.$store.state.game
    }
  },
  computed: {
    locale() { return this.$store.state.lang },
    gsrResults() { return this.$store.state.gsr[this.game] },
    successfulHits() { return this.$store.state.scores[this.game] < 0 ? 0 : this.$store.state.scores[this.game] },
    getOptions() {
      const { LevelComplete } =  SVGS[ this.locale.LOCALE ]

      return {
        animationData: LevelComplete.default,
        autoplay: false,
        loop: false
      }
    },
    isMobile() { return this.$store.state.isMobile },
    endResultCopy() {
      return this.isMobile ? this.locale.TRIGGER_RESULTS_MOBILE : this.locale.TRIGGER_RESULTS
    },
    nextLevelCopy() {
      return this.isMobile ? this.locale.TRIGGER_CONTINUE_MOBILE : this.locale.TRIGGER_CONTINUE_NEXT_LEVEL
    },
    getContinueButtonCopy() {
      return this.level === 3 ? this.endResultCopy : this.nextLevelCopy
    },
    getContinueButtonState() {
      return this.level === 3 ? 'result' : 'next'
    },
  },
  mounted() {
    this.initIdleStates()
    this.createAnimationTimeline()

    this.$store.commit( 'setBackgroundVideoState', { isBackgroundVideoPlaying: true } )
    this.$store.commit( 'setIsIdleLoopPlaying', { isIdleLoopPlaying: true } )

  },
  beforeRouteLeave( to, from, next ) {
    this.$store.commit( 'setBackgroundVideoState', { isBackgroundVideoPlaying: false } )
    this.$store.commit( 'setTransitionVisibility', { isTransitionVisible: true } )

    if ( this.level != 3 ) {
        this.$store.commit( 'setLevel', { level: this.level + 1 } )
        this.$store.commit( 'setGame', { game: this.games[this.level] } )
    }

    setTimeout( () => { next() }, 450 )

  },
  methods: {
    initIdleStates() {

    },
    createAnimationTimeline() {
      const { Lottie_LevelComplete, ProgressIndicator, AchievementIndicator, ContinueButton } = this.$refs

      this.animateElementsIn = new TimelineLite( { paused: false } )

      this.animateElementsIn
        .add( () => { Lottie_LevelComplete.play() }, 0.3 )
        .add( () => { levelFlickerAudio.play() }, 0.3 )
        .add( () => { ProgressIndicator.animateElementsIn.play() }, 0.3 )
        .add( () => { AchievementIndicator.animateElementsIn.play() }, 0.3 )
        .add( () => { ContinueButton.animateElementsIn.play() }, 0.3 )
    },
    proceed() {
      if ( this.level == 3 ) {

        this.$router.push( { name: 'result', query: { lang: this.locale.LOCALE } } )

      } else {

        this.$router.push( { name: 'level', query: { lang: this.locale.LOCALE } } )
      }
    }
  }
}
</script>

<style scoped lang="scss">

  @import '@/styles/core.scss';

  .LevelResult {

    height: 100%;
    width: 100%;

    min-height: $page-min-height;

    display: flex;
    justify-content: center;
    align-items: center;

    @include breakpoint( mobile-all ) {

      min-height: 100%;

    }

    .LottieWrapper {

      margin: 0 auto;

      max-width: rem( 400 );
      width: 100%;

    }

    .ProgressIndicator,
    .AchievementIndicator {

      min-width: rem( 400 );

      margin-bottom: rem( 40 );

      @include breakpoint( mobile-all ) {

        margin-bottom: rem( 40 );
        min-width: 100%;

      }

      @include breakpoint-width( 375px, 667px ) {

        margin-bottom: rem( 20 );

      }

    }

  }

</style>
